
<!-- <div class="flex alignCenter">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <button mat-icon-button type="button" (click)="fileInput.click()">
                <mat-icon>attach_file</mat-icon>
            </button>
            <input hidden (change)="prepareFilesList($event)" #fileInput type="file">
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="file-upload-status flex alignCenter">
                <div class="file-upload-name-info flex alignCenter">
                    <mat-icon>check_circle</mat-icon>
                    <span> {{files[0]?.name}} </span>
                </div>
                <div class="file-upload-size-info alignCenter">
                    <span>{{file[0].size}}</span>
                    <mat-icon>delete_outline</mat-icon>
                </div>
            </div>
        </div>
    </div>
</div> -->

<div class="container">
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <ng-container *ngIf="fileUploadConfig.buttonName; else iconButton">
                <button mat-raised-button class="ml-5 btnCustom btn-primary" 
                    color="warn" type="button" 
                (click)="fileInput.click()">{{fileUploadConfig.buttonName}}
            </button>
            </ng-container>
            <ng-template #iconButton>
                <button mat-icon-button type="button" (click)="fileInput.click()">
                    <mat-icon>attach_file</mat-icon>
                </button>
            </ng-template>
            
            <input hidden (change)="prepareFilesList($event)" accept="{{fileFormats}}" #fileInput type="file">
            <span *ngIf="loader">
                <span class="loader"></span>
            </span>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <small><b>Supported Formats: </b>{{fileFormats}}</small>
        </div>
    </div>
    <div class="file-upload-status flex alignCenter" *ngIf="files?.length">
        <div>
            <div class="file-upload-name-info flex alignCenter">
                <mat-icon>check_circle</mat-icon>
                <span class="file-name"
                matTooltip="{{files[0]?.name}}"
                matTooltipPosition="left"> {{files[0]?.name}}</span>
            </div>
        </div>
        <div class="flex file-upload-size-info alignCenter">
            <span class="file-size"> {{fileSizeConvert(files[0]?.size)}}</span>
            <mat-icon (click)="deleteAttachedFile()">delete_outline</mat-icon>
            <mat-icon (click)="downloadAttachedFile()">save_alt</mat-icon>
        </div>
    </div>
</div>
